export default {
  'FOLLOW_UP_RULE' (state) {
    return state.followUpRule
  },
  'FOLLOW_UP_RULES' (state) {
    return state.followUpRules
  }
}
